let elements = {
  mainImage: {
    imagePath: 'games/page002_game2/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  withoutCheck: false,
  columns: 4,
  audio: {
    negative: 'games/page002_game2/audio/f.mp3',
    positive: 'games/page002_game2/audio/true.mp3',
    click: 'games/page002_game2/audio/t.mp3',
  },
  curtain: 'transparent',
  curtainImage: {
    src: 'games/page002_game2/img/des.png',
  },
  width: 300,
  height: 300,
  // goodAudio: 'games/page002_game2/audio/z2c2.mp3',
  fields: [
    {
      id: 0,
      image: {
        src: 'games/page002_game2/img/00.png',
      },
    },
    {
      id: 0,
      image: {
        src: 'games/page002_game2/img/00.png',
      },
    },
    {
      id: 1,
      image: {
        src: 'games/page002_game2/img/01.png',
      },
    },
    {
      id: 1,
      image: {
        src: 'games/page002_game2/img/01.png',
      },
    },
    {
      id: 2,
      image: {
        src: 'games/page002_game2/img/02.png',
      },
    },
    {
      id: 2,
      image: {
        src: 'games/page002_game2/img/02.png',
      },
    },
    {
      id: 3,
      image: {
        src: 'games/page002_game2/img/03.png',
      },
    },
    {
      id: 3,
      image: {
        src: 'games/page002_game2/img/03.png',
      },
    },
  ],
  // mbAudioItemData: [
  // ],
};

export default elements;
